import * as React from 'react';
export const taxamoSvg = React.forwardRef(function taxamoSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#000',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M27.994 15.948c0-.555-.396-.958-.944-.96-.55-.003-.949.396-.954.952-.006.579.392.982.962.973.552-.007.938-.405.936-.965Zm-2.893 0c.001-1.02.888-1.856 1.958-1.847 1.074.01 1.939.846 1.934 1.871-.005.999-.882 1.826-1.941 1.83-1.073.004-1.952-.832-1.951-1.854Zm-5.375 1.777h-.942v-3.523h.92l.04.364c1.008-.66 1.656-.608 2.247.184.385-.467.876-.707 1.522-.606.565.09.983.458 1.009 1.01.039.848.01 1.698.01 2.567h-.95c0-.416.002-.83-.001-1.245-.004-.32-.003-.641-.027-.96-.02-.265-.15-.465-.472-.498-.345-.036-.662.013-.812.341a1.31 1.31 0 0 0-.104.514c-.012.606-.004 1.213-.004 1.844h-1v-.438c0-.552.004-1.105-.004-1.658-.005-.369-.164-.56-.474-.603-.415-.057-.76.096-.868.422-.062.187-.083.39-.086.587-.011.56-.004 1.121-.004 1.698Zm-2.66-1.756c.002-.57-.37-.953-.932-.96-.57-.008-.948.362-.957.932-.007.582.388.998.944.994.54-.006.942-.417.944-.965Zm-.02-1.36.04-.406h.955v3.52h-.953l-.033-.294c-.308.125-.613.316-.943.367-.724.113-1.39-.234-1.694-.86-.386-.794-.344-1.576.248-2.277.556-.657 1.544-.72 2.224-.174l.157.124Zm-6.232-.394c.682-.073 1.286-.146 1.646.595.38-.734.988-.678 1.666-.594l-1.644 1.747 1.655 1.75c-.675.04-1.3.164-1.658-.62-.36.733-.97.685-1.663.61l1.646-1.74-1.648-1.748Zm-2.314.794c-.566-.004-.945.37-.952.94-.006.56.377.97.922.985.544.015.974-.415.974-.973 0-.566-.38-.947-.944-.952Zm.934-.423.028-.382h.953v3.52h-.957l-.025-.293c-.338.128-.66.324-1.004.366-.765.094-1.412-.296-1.701-.96a2.068 2.068 0 0 1 .01-1.743c.48-1.05 1.629-1.272 2.696-.508Zm-5.094 3.13v-3.61H2.993v-.86h3.68v.843H5.32v3.626h-.98Z',
      fill: '#FEFEFE',
    }),
  );
});
taxamoSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var taxamo = {
  category: 'brand',
  colorable: false,
  name: 'taxamo',
  svg: taxamoSvg,
};
